import styled from 'styled-components';
import { RaisedButton } from '../../assets/styles/BaseStyle';

// Modal styles
export const ModalOverlay = styled.div`
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  background: #fff;
  border-radius: 10px;
//  min-width: 300px;
  max-width: 90vw;
  padding: 24px;
  box-shadow: 0 4px 32px rgba(0,0,0,0.18);
  position: relative;
`;

export const ModalTitle = styled.h4`
  margin: 0 0 16px 0;
  color: #333;
  text-align: ${props => props.isRtl ? 'right' : 'left'};
  direction: ${props => props.isRtl ? 'rtl' : 'ltr'};
  @media (max-width: 480px) {
    ${props => props.isRtl && 'width: 80%;'}
  }
   @media (max-width: 320px) {
    ${props => props.isRtl && 'width: 80%;'}
  }
`;

export const ModalInput = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
  outline: none;
  box-sizing: border-box;
  text-align: ${props => props.isRtl ? 'right' : 'left'};
  direction: ${props => props.isRtl ? 'rtl' : 'ltr'};

    @media (max-width: 480px) {
      font-size: 15px;
      padding: 10px;
      width: 80%;
     // margin-left: ${props => props.isRtl ? '20px' : '0'};
    }

    @media (max-width: 320px) {
      font-size: 14px;
      padding: 8px;
      width: 80%;
      
    }
  
`;

export const ModalHelpText = styled.div`
  font-size: 12px;
  color: #666;
  margin-top: 4px;
  text-align: ${props => props.isRtl ? 'right' : 'left'};
  direction: ${props => props.isRtl ? 'rtl' : 'ltr'};
@media (max-width: 480px) {
    ${props => props.isRtl && 'width: 80%;'}
  }
   @media (max-width: 320px) {
    ${props => props.isRtl && 'width: 80%;'}
  }
`;

export const ModalButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: ${props => props.isRtl ? 'flex-start' : 'flex-end'};
  flex-direction: ${props => props.isRtl ? 'row-reverse' : 'row'};

   @media (max-width: 480px) {
    gap: 6px;
    flex-direction: column-reverse;
    align-items: stretch;
    justify-content: center;
    width: 80%;

  }

  @media (max-width: 320px) {
    gap: 6px;
    flex-direction: column-reverse;
    align-items: stretch;
    justify-content: center;
    width: 80%;
  }
`;

export const ModalButton = styled.button`
  padding: 10px 20px;
  border: ${props => props.variant === 'cancel' ? '1px solid #ddd' : 'none'};
  border-radius: 6px;
  background: ${props => {
    if (props.variant === 'cancel') return '#fff';
    if (props.disabled) return '#ccc';
    return '#007bff';
  }};
  color: ${props => props.variant === 'cancel' ? '#666' : '#fff'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 14px;
  text-align: ${props => props.isRtl ? 'right' : 'left'};
  direction: ${props => props.isRtl ? 'rtl' : 'ltr'};
`;

// Tile styles
export const Tile = styled.div`
  cursor: pointer;
  border-radius: 8px;
  border: ${props => props.selected ? '3px solid #007bff' : '3px solid white'};
  box-shadow: ${props => props.selected
    ? '0 2px 8px rgba(0,123,255,0.15)'
    : '0 2px 8px rgba(0,0,0,0.07)'
  };
  background: #fff;
  overflow: hidden;
  margin: 8px;
  width: ${props => props.isPortrait ? '600px' : '180px'};
  min-height: ${props => props.isPortrait ? '200px' : props.label ? '200px' : '230px'};
  max-height: ${props => props.isPortrait ? '150px' : '200px'};
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: border 0.2s, box-shadow 0.2s;
  position: relative;

  @media (max-width: 1200px) {
    width: ${props => props.isPortrait ? '500px' : '160px'};
  }

  @media (max-width: 768px) {
    width: ${props => props.isPortrait ? '400px' : props.columns === 3 ? '120px' : '140px'};
    min-height: ${props => props.isPortrait ? '130px' : '160px'};
  }

  @media (max-width: 480px) {
    width: ${props => props.isPortrait ? '300px' : props.columns === 3 ? '100px' : '120px'};
    min-height: ${props => props.isPortrait ? '90px' : props.columns === 3 ? '100px' : '140px'};
    max-height: ${props => props.isPortrait ? '130px' : props.columns === 3 ? '150px' : '180px'};
  }

  @media (max-width: 320px) {
    width: ${props => props.isPortrait ? '200px' : props.columns === 3 ? '80px' : '100px'};
    min-height: ${props => props.isPortrait ? '70px' : props.columns === 3 ? '100px' : props.label ? '140px' : '120px'};
    max-height: ${props => props.isPortrait ? '130px' : props.columns === 3 ? '130px' : '180px'};
  }
`;

export const TileImageContainer = styled.div`
  width: 100%;
  height: 230px;
  overflow: hidden;
  background: #f7f7f7;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    height: 200px;
  }

  @media (max-width: 480px) {
    height: 180px;
  }

  @media (max-width: 320px) {
    height: 120px;
  }
`;

export const TileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${props => props.selected ? 1.5 : 1};
  filter: ${props => props.selected ? 'none' : 'grayscale(0.2)'};
`;

export const TileLabel = styled.div`
  margin-top: 0;
  font-weight: ${props => props.selected ? 'bold' : 'normal'};
  color: ${props => props.selected ? '#007bff' : '#333'};
  text-align: center;
  font-size: 15px;
  padding: 0 6px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 32px;

  @media (max-width: 768px) {
    font-size: 14px;
    min-height: 35px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    min-height: 30px;
    padding: 0 4px;
  }

  @media (max-width: 320px) {
    font-size: 10px;
    min-height: 25px;
    padding: 0 2px;
  }
`;

export const TileCheckmark = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #007bff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0 1px 4px rgba(0,0,0,0.12);

  @media (max-width: 480px) {
    width: 16px;
    height: 16px;
    font-size: 12px;
    top: 6px;
    right: 6px;
  }
`;

// Grid styles
export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: ${props => {
    if (props.isPortrait) {
      return `repeat(${props.columns}, minmax(600px, 1fr))`;
    }
    return `repeat(${props.columns}, minmax(150px, 1fr))`;
  }};
  gap: 20px;
  justify-content: center;
  margin-top: 12px;
  width: 100%;
  max-width: ${props => props.columns * 200}px;
  min-height: 500px;

  @media (max-width: 1200px) {
    grid-template-columns: ${props => {
      if (props.isPortrait) {
        return `repeat(${props.columns}, minmax(500px, 1fr))`;
      }
      return `repeat(${props.columns}, minmax(140px, 1fr))`;
    }};
    gap: 16px;
    max-width: ${props => props.columns * 180}px;
  }

  @media (max-width: 768px) {
    grid-template-columns: ${props => {
      if (props.isPortrait) {
        return `repeat(${props.columns}, minmax(400px, 1fr))`;
      }
      return `repeat(${props.columns}, minmax(120px, 1fr))`;
    }};
    gap: ${props => props.columns === 3 ? '8px' : props.columns === 2 ? '10px' : '10px'};
    max-width: ${props => props.columns * 160}px;
    min-height: 400px;
    margin-right: ${props => props.columns === 3 ? '30px' : props.columns === 2 ? '0' : '0'};
  }

  @media (max-width: 480px) {
    grid-template-columns: ${props => {
      if (props.isPortrait) {
        return `repeat(${props.columns}, minmax(300px, 1fr))`;
      }
      if (props.columns === 3) {
        return `repeat(${props.columns}, minmax(80px, 1fr))`;
      }
      return `repeat(${props.columns}, minmax(100px, 1fr))`;
    }};
    gap: 4px;
    max-width: ${props => props.columns * 130}px;
    min-height: 300px;
    margin-right: 12px;
  }

   @media (max-width: 320px) {
    grid-template-columns: ${props => {
      if (props.isPortrait) {
        return `repeat(${props.columns}, minmax(200px, 1fr))`;
      }
      if (props.columns === 3) {
        return `repeat(${props.columns}, minmax(80px, 1fr))`;
      }
      return `repeat(${props.columns}, minmax(100px, 1fr))`;
    }};
    gap: ${props => props.columns === 3 ? '2px' : props.columns === 2 ? '10px' : '10px'};
    max-width: ${props => props.columns * 100}px;
    min-height: 120px;
    margin-left: ${props => props.columns === 3 ? '30px' : props.columns === 2 ? '20px' : '20px'};
  }
`;

// Other option styles
export const OtherOptionContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const OtherOptionButton = styled.div`
  cursor: pointer;
  padding: 12px 24px;
  border: ${props => props.selected ? '2px solid #007bff' : '1px solid #e0e0e0'};
  border-radius: 8px;
  background: ${props => props.selected ? '#f0f8ff' : '#fff'};
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
  min-width: 200px;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 10px 20px;
    min-width: 180px;
  }

  @media (max-width: 480px) {
    padding: 8px 16px;
    min-width: 160px;
    gap: 6px;
  }
`;

export const OtherOptionRadio = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: ${props => props.selected ? '2px solid #007bff' : '2px solid #ccc'};
  background: ${props => props.selected ? '#007bff' : 'transparent'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
  font-weight: bold;

  @media (max-width: 480px) {
    width: 16px;
    height: 16px;
    font-size: 10px;
  }
`;

export const OtherOptionText = styled.span`
  color: ${props => props.selected ? '#007bff' : '#333'};
  font-weight: ${props => props.selected ? 'bold' : 'normal'};

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

// Image container for main image
export const MainImageContainer = styled.div`
  margin-bottom: 16px;
`;

export const MainImage = styled.img`
  max-width: 320px;
  width: 100%;
  border-radius: 8px;

  @media (max-width: 768px) {
    max-width: 280px;
  }

  @media (max-width: 480px) {
    max-width: 240px;
  }
`;

// Legacy styles (keeping for backward compatibility)
export const ImageButton = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  margin-bottom: 20px;
  
  button {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    width: 26%;
    margin: 15px 30px;
    padding: 10px;
    overflow: hidden;
    border: 0px solid #BD1E6F;
    background-color: #fff;
    
    &.selected {
      border: 2px solid #BD1E6F;
    }
    
    img {
      max-width: 100%;
      margin-bottom: 10px;
    }
    
    label {
      display: block;
    }

    @media (min-width: 992px) and (max-width: 1275px) {
      width: 27%;
      margin: 15px 18px;
    }
    
    @media (min-width: 768px) and (max-width: 991px) {
      width: 26%;
      margin: 15px 16px;
    }
    
    @media (min-width: 576px) and (max-width: 767px) {
      width: 26%;
      margin: 12px;
    }

    @media (min-width: 320px) and (max-width: 575px) {
      width: 26%;
      margin: 15px 10px;
    }

    &.help-div {
      margin: 15px;
      cursor: auto !important;
      
      &:active,
      &.active {
        box-shadow: 0 0px 6px rgba(0, 0, 0, 0.3), 0 6px 12px rgba(0, 0, 0, 0.4);
      }
      
      @media (min-width: 992px) and (max-width: 1275px) {
        width: 27%;
        margin: 12px;
      }
      
      @media (min-width: 768px) and (max-width: 991px) {
        width: 26%;
        margin: 4px;
      }
      
      @media (min-width: 576px) and (max-width: 767px) {
        width: 26%;
        margin: 12px;
      }
  
      @media (min-width: 320px) and (max-width: 575px) {
        width: 26%;
        margin: 15px 10px;
      }
    }
  }
`;

export const Item = styled(RaisedButton)`
  // Legacy styles can be added here if needed
`;